module.exports = __webpack_public_path__ + "static/img/6.bf42abb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/2/6.png
// module id = SI4V
// module chunks = 0